(function(){
  function material(v){ return String(v || '').trim().toUpperCase(); }
  function looksCompleteMaterial(term){
    var value = material(term);
    return /^[A-Z0-9]+(?:\.[A-Z0-9-]+){2,}$/.test(value) ? value : '';
  }

  document.querySelectorAll('.t100parts[data-t100parts]').forEach(function(root){
    var search = root.querySelector('.t100parts__search');
    var rows = root.querySelector('[data-t100-rows]');
    var empty = root.querySelector('[data-t100-empty]');
    var count = root.querySelector('[data-t100-count]');
    var more = root.querySelector('[data-t100-more]');
    if (!search || !rows || !empty) return;

    var emptyTitle = empty.querySelector('strong');
    var emptyCopy = empty.querySelector('span');
    var defaultTitle = emptyTitle ? emptyTitle.textContent : 'No matching T100 parts found.';
    var defaultCopy = emptyCopy ? emptyCopy.textContent : '';
    var applying = false;

    function restoreCopy(){
      if (emptyTitle) emptyTitle.textContent = defaultTitle;
      if (emptyCopy) emptyCopy.textContent = defaultCopy;
      empty.removeAttribute('data-exact-material-miss');
    }

    function enforce(){
      if (applying) return;
      applying = true;
      var exactTerm = looksCompleteMaterial(search.value);
      var allRows = Array.prototype.slice.call(rows.querySelectorAll('[data-part-row]'));

      if (!exactTerm) {
        allRows.forEach(function(row){ row.hidden = false; });
        restoreCopy();
        applying = false;
        return;
      }

      var exactRows = allRows.filter(function(row){
        var node = row.querySelector('.t100parts__material');
        return material(node && node.textContent) === exactTerm;
      });

      if (exactRows.length) {
        allRows.forEach(function(row){ row.hidden = exactRows.indexOf(row) === -1; });
        if (count) count.textContent = exactRows.length;
        if (more) more.hidden = true;
        empty.hidden = true;
        restoreCopy();
      } else {
        allRows.forEach(function(row){ row.hidden = true; });
        if (count) count.textContent = '0';
        if (more) more.hidden = true;
        empty.hidden = false;
        empty.setAttribute('data-exact-material-miss','true');
        if (emptyTitle) emptyTitle.textContent = 'No exact T100 material-number match found.';
        if (emptyCopy) emptyCopy.textContent = 'We will not substitute a different SKU for a complete material number. Check the number on the component, or ask TJ Aerosense to verify it before ordering.';
      }
      applying = false;
    }

    function schedule(){ window.requestAnimationFrame(enforce); }
    search.addEventListener('input', schedule);
    root.addEventListener('click', function(){ window.setTimeout(enforce,0); }, true);
    new MutationObserver(schedule).observe(rows,{childList:true,subtree:true});
    schedule();
  });
})();
